import React from "react";
import BaseCallout, {
  type SharedCalloutProps,
} from "components/callout/BaseCallout";

export type CalloutProps = Omit<
  SharedCalloutProps,
  "centerContent" | "buttonClassName"
>;

/**
 * Universal callout component used across homepage sections.
 * Supports multiple accent themes with optional markdown rendering and button link.
 *
 * @example
 * <Callout
 *   callout={{ title: "Hero callout", description: "Description", buttonLabel: "CTA", accent: "sifted" }}
 *   href="/path"
 *   fixedHeight
 *   titleSize="small"
 * />
 */
const Callout: React.FC<CalloutProps> = ({
  renderMarkdown = false,
  fixedHeight = false,
  titleSize = "large",
  ...props
}) => {
  return (
    <BaseCallout
      {...props}
      renderMarkdown={renderMarkdown}
      fixedHeight={fixedHeight}
      titleSize={titleSize}
      centerContent={false}
      buttonClassName="mt-2"
    />
  );
};

Callout.displayName = "Callout";

export default Callout;
